module.exports = __webpack_public_path__ + "img/payroll.03fb0276.svg";